"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = exports.AccordionBody = exports.AccordionHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ChevronUp = _interopRequireDefault(require("../../icons/ChevronUp"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AccordionContext = (0, _react.createContext)({
  isExpanded: false,
  handleClick: function handleClick() {
    return null;
  }
});

var AccordionHeader = function AccordionHeader(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$caretClassName = _ref.caretClassName,
      caretClassName = _ref$caretClassName === void 0 ? '' : _ref$caretClassName,
      _ref$caretStyle = _ref.caretStyle,
      caretStyle = _ref$caretStyle === void 0 ? {} : _ref$caretStyle,
      _ref$clickAnywhere = _ref.clickAnywhere,
      clickAnywhere = _ref$clickAnywhere === void 0 ? false : _ref$clickAnywhere,
      children = _ref.children;
  return _react.default.createElement(AccordionContext.Consumer, null, function (_ref2) {
    var isExpanded = _ref2.isExpanded,
        handleClick = _ref2.handleClick;
    return _react.default.createElement("h4", {
      className: "text-sm font-bold p-3 w-full flex flex-row justify-between items-center ".concat(className, " ").concat(clickAnywhere ? 'cursor-pointer' : ''),
      onClick: function onClick() {
        return clickAnywhere && handleClick();
      }
    }, children, _react.default.createElement(_ChevronUp.default, {
      alt: "Toggle visibility",
      "data-testid": "visibility-toggle",
      className: "inline cursor-pointer mx-1 ".concat(caretClassName),
      style: _objectSpread({
        transform: "translate(0px, 0px) scale(0.6, 0.6) ".concat(isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'),
        transformOrigin: 'center',
        transition: '0.3s ease-out'
      }, caretStyle),
      onClick: handleClick
    }));
  });
};

exports.AccordionHeader = AccordionHeader;
AccordionHeader.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  clickAnywhere: _propTypes.default.bool,
  caretClassName: _propTypes.default.string,
  caretStyle: _propTypes.default.shape({})
};

var AccordionBody = function AccordionBody(_ref3) {
  var children = _ref3.children,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {} : _ref3$style;
  return _react.default.createElement(AccordionContext.Consumer, null, function (_ref4) {
    var isExpanded = _ref4.isExpanded;
    return _react.default.createElement("div", {
      className: "overflow-hidden transition-all duration-300 ".concat(className),
      style: _objectSpread({
        height: isExpanded ? 'auto' : 0,
        opacity: isExpanded ? 1 : 0,
        overflow: 'hidden'
      }, style)
    }, children);
  });
};

exports.AccordionBody = AccordionBody;
AccordionBody.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  style: _propTypes.default.shape({})
};

var Accordion = function Accordion(_ref5) {
  var children = _ref5.children,
      _ref5$expanded = _ref5.expanded,
      expanded = _ref5$expanded === void 0 ? null : _ref5$expanded,
      onChange = _ref5.onChange;

  var _useState = (0, _react.useState)(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!(0, _lodash.isNull)(expanded) && expanded !== isExpanded) {
      setIsExpanded(expanded);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [expanded]);

  var handleClick = function handleClick() {
    setIsExpanded(!isExpanded);
    onChange && onChange(!isExpanded);
  };

  return _react.default.createElement(AccordionContext.Provider, {
    value: {
      isExpanded: isExpanded,
      handleClick: handleClick
    }
  }, children);
};

exports.Accordion = Accordion;
Accordion.propTypes = {
  children: _propTypes.default.node.isRequired,
  expanded: _propTypes.default.bool,
  onChange: _propTypes.default.func
};